import React, { useEffect, useState } from "react";
import { fireDB } from "../../firebase/FirebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import { useParams } from "react-router-dom";
import { Container, Card } from "react-bootstrap";

const BlogDetails = () => {
    const { id } = useParams();
    const [blog, setBlog] = useState(null);

    const getBlog = async () => {
        const docRef = doc(fireDB, "blogs", id);
        const snap = await getDoc(docRef);
        if (snap.exists()) {
            setBlog(snap.data());
        }
    };

    useEffect(() => {
        getBlog();
    }, []);

    if (!blog) return <p className="text-center mt-5">Loading...</p>;

    return (
        <Container className="my-5">
            <Card className="shadow-lg rounded-4 border-0 p-4">

                {/* Title */}
                <h1 className="fw-bold mb-3 text-center">
                    {blog.title || "Untitled Blog"}
                </h1>

                {/* Date */}
                <p className="text-center text-secondary">
                    📅{" "}
                    <small>
                        {blog.date
                            ? blog.date.toDate().toLocaleDateString()
                            : "No Date"}
                    </small>
                </p>

                {/* Thumbnail */}
                <div className="text-center mb-4">
                    <img
                        src={blog.thumbnail}
                        alt="thumbnail"
                        className="img-fluid rounded-4"
                        style={{
                            maxHeight: "420px",
                            width: "100%",
                            objectFit: "cover",
                        }}
                    />
                </div>

                {/* Content */}
                <div
                    className="blog-content"
                    style={{
                        fontSize: "1.15rem",
                        lineHeight: "1.9",
                        color: "#333",
                        whiteSpace: "pre-line",
                    }}
                >
                    {blog.content || ""}
                </div>
            </Card>
        </Container>
    );
};

export default BlogDetails;
